import { downgradeInjectable } from '@angular/upgrade/static';
import * as angular from 'angular';
import { TermsService } from '@go-modules/services/terms/terms.service';

export const ngxTermsServiceModule = angular.module('ngxTermsServiceModule', [])
	.factory('ngxTermsService', downgradeInjectable(TermsService) as any)
	.name;
